import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "./ChartCard"
import { PALETTE, formatShort, NIVO_THEME } from "./palette"

const TopClientsChart = ({ data }) => {
  const rows = data.map(d => ({ name: d.name, value: d.value, formatted: d.formatted }))
  return (
    <ChartCard
      icon     = "ranking-star"
      title    = {I18n.t("chantiers_dashboard.charts.top_clients")}
      subtitle = {I18n.t("chantiers_dashboard.charts.top_clients_hint")}
      height   = {300}
      empty    = {rows.length === 0 ? I18n.t("chantiers_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data         = {rows}
        keys         = {["value"]}
        indexBy      = "name"
        layout       = "horizontal"
        margin       = {{ top: 18, right: 28, bottom: 32, left: 150 }}
        padding      = {0.28}
        colors       = {[PALETTE.cyan]}
        borderRadius = {3}
        enableLabel  = {false}
        axisBottom   = {{ tickValues: 4, format: (v) => formatShort(v) }}
        axisLeft     = {{ tickSize: 0, tickPadding: 10 }}
        gridXValues  = {4}
        tooltip      = {({ value, indexValue }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "6px 10px", fontSize: 11, borderRadius: 6, boxShadow: "0 8px 20px rgba(15,23,42,0.25)" }}>
            <strong>{indexValue}</strong> · {formatShort(value)}
          </div>
        )}
        theme        = {NIVO_THEME}
      />
    </ChartCard>
  )
}

export default TopClientsChart
